<template>
  <div>
    <div class="float-lg-right mb-3">
      <!-- <download-excel :fetch="fetchData" class="btn btn-outline-success default" :fields="json_fields" name="orderList.xls" :meta="json_meta" :stringifyLongNum="true">Excel
      </download-excel> -->
      <button type="button" class="btn btn-outline-success default" @click="getExcelData">
        Excel
      </button>
    </div>
    <b-table-simple head-variant="light" class="vuetable" responsive>
      <b-thead head-variant="light">
        <b-tr v-if="!useDate">
          <template v-for="(field , idx) in useDateFields">
            <b-th style="text-align: center" :key="idx">{{
                field.label
              }}
            </b-th>

          </template>
        </b-tr>
        <b-tr v-else>
          <template v-for="(field , idx) in useDateFields">
            <b-th style="text-align: center" :key="idx">{{
                field.label
              }}
            </b-th>

          </template>
        </b-tr>

      </b-thead>
      <b-tbody>
        <template v-for="(item , i ) in orderList">
          <b-tr :key="i" v-if="Number(item.listPrice )>= 0">
            <b-td style="text-align:center">{{ item.useDate.substr(0, 10) }}</b-td>
            <b-td style="text-align:center">
              <span>{{ itemNoVal(item.itemNo) }}</span>
            </b-td>
            <b-td style="text-align:center">{{ goodsTypeVal(item.goodsType) }}</b-td>
            <b-td style="text-align:center">{{ item.goodsName }}</b-td>
            <b-td style="text-align:center">{{ item.optionName }}</b-td>
            <b-td style="text-align:center" v-if="String(fullPath).includes('sales-amount')">{{ item.listPrice | currency }}</b-td>
            <b-td style="text-align:center">{{ item.originalSalePrice | currency }}</b-td>
            <b-td style="text-align:center">{{ item.salePrice | currency }}</b-td>
            <b-td style="text-align:center">{{ buyerName(item.buyerName) }}</b-td>
            <b-td style="text-align:center">
              <div v-if="item.selfSales == true">
                O
              </div>
              <div v-else>

              </div>
            </b-td>
          </b-tr>
          <b-tr :key="i" v-else>
            <b-td style="text-align:center; color: red;">{{ item.useDate.substr(0, 10) }}</b-td>
            <b-td style="text-align:center; color: red;">
              <span>{{ itemNoVal(item.itemNo) }}</span>
            </b-td>
            <b-td style="text-align:center; color: red;">{{ goodsTypeVal(item.goodsType) }}</b-td>
            <b-td style="text-align:center; color: red;">{{ item.goodsName }}</b-td>
            <b-td style="text-align:center; color: red;">{{ item.optionName }}</b-td>
            <b-td style="text-align:center; color: red;" v-if="String(fullPath).includes('sales-amount')">{{ item.listPrice | currency }}</b-td>
            <b-td style="text-align:center; color: red;">{{ item.originalSalePrice | currency }}</b-td>
            <b-td style="text-align:center; color: red;">{{ item.salePrice | currency }}</b-td>
            <b-td style="text-align:center; color: red;">{{ buyerName(item.buyerName) }}</b-td>
            <b-td style="text-align:center; color: red;">
              <div v-if="item.selfSales == true " style="text-align:center; color: red;">
                O
              </div>
              <div v-else>

              </div>
            </b-td>
          </b-tr>
        </template>
        <template>
          <b-tr>
            <b-th style="text-align:center;background:#f6c797 !important">합계 :</b-th>
            <b-th style="text-align:center;background:#f6c797 !important" colspan="4"></b-th>
            <b-th style="text-align:center;background:#f6c797 !important"
                  v-if="!String(fullPath).includes('sales-amount')"></b-th>
            <b-th v-if="totalData('listPrice')>=0" style="text-align:center;background:#f6c797 !important;" class="text-center align-middle">
              {{ totalData('listPrice') | currency }}
            </b-th>
            <b-th v-else style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('listPrice') | currency }}
            </b-th>
            <b-th v-if="totalData('originalSalePrice') >=0" style="text-align:center;background:#f6c797 !important;" class="text-center align-middle">
              {{ totalData('originalSalePrice')  | currency}}
            </b-th>
            <b-th v-else style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('originalSalePrice') | currency }}
            </b-th>
            <b-th v-if="totalData('salePrice') >=0" style="text-align:center;background:#f6c797 !important;" class="text-center align-middle">
              {{ totalData('salePrice') | currency }}</b-th>
              <b-th v-else style="text-align:center;background:#f6c797 !important; color: red;" class="text-center align-middle">
              {{ totalData('salePrice') | currency }}</b-th>
            <b-th style="text-align:center;background:#f6c797 !important;"></b-th>
            <b-th style="text-align:center;background:#f6c797 !important;"></b-th>
          </b-tr>
        </template>
      </b-tbody>

    </b-table-simple>

    <!--    <b-pagination size="sm"-->
    <!--                  align="center"-->
    <!--                  :total-rows="total"-->
    <!--                  :per-page="perPage"-->
    <!--                  v-model="currentPage"-->
    <!--    >-->
    <!--      <template v-slot:next-text>-->
    <!--        <i class="simple-icon-arrow-right"/>-->
    <!--      </template>-->
    <!--      <template v-slot:prev-text>-->
    <!--        <i class="simple-icon-arrow-left"/>-->
    <!--      </template>-->
    <!--      <template v-slot:first-text>-->
    <!--        <i class="simple-icon-control-start"/>-->
    <!--      </template>-->
    <!--      <template v-slot:last-text>-->
    <!--        <i class="simple-icon-control-end"/>-->
    <!--      </template>-->
    <!--    </b-pagination>-->

  </div>
</template>

<script>
import {
  mapGetters,
} from "vuex";
import {
  alignTableCenter,
  currencyFilter,
  getGoodsTypeStr
} from "../../../utils";
import VueBarcode from 'vue-barcode';
import XLSX from "xlsx"
import moment from 'moment'
import {order} from '../../../constants/api';

export default {
  components: {
    'barcode': VueBarcode
  },
  props: ['useDate', 'data', 'fullPath'],
  filters: {
    ...currencyFilter
  },
  data() {
    return {
      currentPage: 1,
      perPage: 30,
      total: 0,
      searchDate: null,
      goodsType: null,
      orderList: [],
      barcodeValue: '',
      fields: [{
          key: "date",
          label: "날짜",
          ...alignTableCenter
        },
        {
        key: "couponSerial",
        label: "쿠폰번호",
        ...alignTableCenter
        },
        {
          key: "goodsType",
          label: "상품구분",
          ...alignTableCenter
        },
        {
          key: "goodsName",
          label: "상품명",
          ...alignTableCenter
        },
        {
          key: "optionName",
          label: "옵션명",
          ...alignTableCenter
        },
        {
          key: "listPrice",
          label: "정상가",
          ...alignTableCenter
        },
        {
          key: "originalSalesAmount",
          label: "판매가",
          ...alignTableCenter
        },
        {
          key: "salesAmountTotal",
          label: "실판매가",
          ...alignTableCenter
        },
        {
          key: "Buyer",
          label: "구매자",
          ...alignTableCenter
        },
        {
          key: "selfSales",
          label: "자체판매",
          ...alignTableCenter
        },

      ],
      json_fields: {
        '날짜': 'date',
        '쿠폰번호': 'couponSerial',
        '상품구분': 'goodsType',
        '상품명': 'goodsName',
        '옵션명': 'optionName',
        '정상가': 'listPrice',
        '판매가': 'originalSalePrice',
        '실판매가': 'salePrice',
        '구매자': 'Buyer',
        '자체판매': 'selfSales'
      },
      json_meta: [
        [{
          'key': 'charset',
          'value': 'utf-8'
        }]
      ],
      excelData: []
    }
  },
  computed: {
    ...mapGetters([]),
    useDateFields: {
      get: function () {
        return this.useDate ? [{
          key: 'date',
          label: '사용일',
          ...alignTableCenter
        }, ...this.fields] : this.fields
      }
    }
  },
  mounted() {
    // console.log(this.fullPath)
    if (!String(this.fullPath).includes('sales-amount')) {
      this.fields.splice(4, 1)
    }
  },
  methods: {
    getExcelData() {
      this.fetchData();
      let data =  {
        A: "날짜",
        B: "쿠폰번호",
        C: "상품구분",
        D: "상품명",
        E: "옵션명",
        P: "정상가",
        F: "판매가",
        H: '실판매가',
        N: "구매자",
        O: "자체판매",
      };
      if(!String(this.fullPath).includes('sales-amount')){
        delete data.P;
      }


      let excelheader = XLSX.utils.json_to_sheet(
        [
          data,
        ],
        {skipHeader: true}
      );
      console.log(this.excelData)
      XLSX.utils.sheet_add_json(excelheader, this.excelData.map(this.dataconvert), {
        skipHeader: true,
        origin: "A2",
      });
      let wb = XLSX.utils.book_new(); // make Workbook of Excel

      XLSX.utils.book_append_sheet(wb, excelheader, "orderList");
      // export Excel file
      XLSX.writeFile(wb, "orderList.xlsx");
    },
    dataconvert(oreder, idx) {
      let data =  {
        A: oreder.useDate,//사용일
        B: oreder.couponSerial, //쿠폰번호
        C: oreder.goodsType,// 상품구분
        D: oreder.goodsName,//상품명
        E: oreder.optionName,//옵션명
        P: Number(oreder.listPrice),//정상가
        F: Number(oreder.originalSalePrice),//판매가
        H: Number(oreder.salePrice),//실판매가
        N: oreder.Buyer,
        O: oreder.selfSales,
      };
      if(!String(this.fullPath).includes('sales-amount')){
        delete data.P;
      }
      return data;
    },
    goodsTypeVal(val) {
      return getGoodsTypeStr(val);
    },
    itemNoVal(val) {
      let item = val.substr(0,3);
      for(let i = 0; i<val.length -3; i ++) {
          item+= "*";
      }
      return item;
    },
    buyerName(val) {
      let buyer ="";
      if(val.length == 1) {
        buyer +="*";
      } else if (val.length == 2) {
        buyer = val.substr(0,1) + "*";
      } else {
        buyer = val.substr(0,1)
        for(let i = 1; i< val.length-1; ++i) {
          buyer+= "*";
        }
        buyer += val.substr(val.length-1,val.length);
      }
      return buyer;
    },
    totalData(data) {
      let originalSalePrice = 0,
        listPrice = 0,
        salePrice = 0
      this.orderList.forEach((el) => {
        originalSalePrice += Number(el.originalSalePrice);
        listPrice += Number(el.listPrice);
        salePrice += Number(el.salePrice);
      });
      if (data == "count") {
        return count;
      } else if (data == "originalSalePrice") {
        // return originalSalePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return originalSalePrice;
      } else if (data == "listPrice") {
        return listPrice;
      } else if (data == "salePrice") {
        return salePrice;
      }
    },

    init(date, goodsType, item) {
      this.searchDate = date
      this.goodsType = goodsType
      this.item = item
      this.loadData()
    },

    loadData() {

      /**
       * 1. 특정날짜, 특정상품유형
       * 2. 모든날짜, 특정상품유형(하단합계)
       * 3. 특정날짜, 모든상품유형
       * 4. 모든날짜, 모든상품유형(우측합계)
       */

      const vm = this
      this.orderList = []

      if (this.searchDate == null) { //모든날짜

        this.item.forEach(function (v, index) {

          //goodsType : Booking, BookingCoupon, MobileCoupon, Summary(정산현황), null(매출현황)
          if (vm.goodsType == null) {
            v.orders.forEach(function (vv, index) {
              vv.orderItems.forEach(function (vvv, index) {
                vm.orderList.push(vvv)
              })
            })
          }

          if (v.Default != null && (vm.goodsType == "Default" || vm.goodsType == "Summary")) {
            v.Default.orders.forEach(function (vv, index) {
              vv.orderItems.forEach(function (vvv, index) {
                vm.orderList.push(vvv)
              })
            })
          }

          if (v.SelfSales != null && (vm.goodsType == "SelfSales" || vm.goodsType == "Summary")) {
            v.SelfSales.orders.forEach(function (vv, index) {
              vv.orderItems.forEach(function (vvv, index) {
                vm.orderList.push(vvv)
              })
            })
          }

        })

      } else {

        if (this.item.Default != null && (this.goodsType == "Default" || this.goodsType == "Summary")) {
          this.item.Default.orders.forEach(function (v, index) {
            v.orderItems.forEach(function (vv, index) {
              vm.orderList.push(vv)
            })
          })
        }

        if (this.item.SelfSales != null && (this.goodsType == "SelfSales" || this.goodsType == "Summary")) {
          this.item.SelfSales.orders.forEach(function (v, index) {
            v.orderItems.forEach(function (vv, index) {
              vm.orderList.push(vv)
            })
          })
        }

      }
    },


    fetchData() {
      this.excelData = [];
      this.orderList.forEach((v) => {
        let selfs;
        if (v.selfSales == true) {
          selfs = 'O';
        } else {
          selfs = '';
        }

        let newStr = v.itemNo
        this.excelData.push({
          'useDate': moment(v.useDate).format('YYYY-MM-DD HH:mm'),
          'goodsType': this.goodsTypeVal(v.goodsType),
          'couponSerial': this.itemNoVal(v.itemNo),
          'goodsName': v.goodsName,
          'optionName': v.optionName,
          'listPrice': Number(v.listPrice),
          'originalSalePrice': Number(v.originalSalePrice),
          'salePrice': Number(v.salePrice),
          'Buyer': this.buyerName(v.buyerName),
          'selfSales': selfs,
        })
      })
      this.excelData.push({
          'useDate': '합계 :',
          'listPrice': this.totalData('listPrice'),
          'originalSalePrice': this.totalData('originalSalePrice'),
          'salePrice': this.totalData('originalSalePrice'),
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
.barcode {
  background: none;
  border: 1px solid #c11314;
  color: #c11314;
  border-radius: 0;
  margin-left: 5px;
}

.table .thead-light th {
  border: 1px solid #fff !important;
  vertical-align: middle;
}
</style>
